"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = exports.Messenger = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Instagram = _interopRequireDefault(require("../../../../icons-react/messengers/Instagram"));
var _Whatsapp = _interopRequireDefault(require("../../../../icons-react/messengers/Whatsapp"));
var _Telegram = _interopRequireDefault(require("../../../../icons-react/messengers/Telegram"));
var _TelegramWithoutBg = _interopRequireDefault(require("../../../../icons-react/messengers/TelegramWithoutBg"));
var _FacebookMessenger = _interopRequireDefault(require("../../../../icons-react/messengers/FacebookMessenger"));
var _Facebook = _interopRequireDefault(require("../../../../icons-react/messengers/Facebook"));
var _Viber = _interopRequireDefault(require("../../../../icons-react/messengers/Viber"));
var _Mail = _interopRequireDefault(require("../../../../icons-react/messengers/Mail"));
var _Vk = _interopRequireDefault(require("../../../../icons-react/messengers/Vk"));
var _Default = _interopRequireDefault(require("../../../../icons-react/messengers/Default"));
var TYPES = exports.TYPES = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
  TELEGRAM_WITHOUT_BG: 'telegram_without_bg',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  FACEBOOK: 'facebook',
  VIBER: 'viber',
  MAIL: 'mail',
  VK: 'vk'
};
var ICONS = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, TYPES.INSTAGRAM, /*#__PURE__*/_react["default"].createElement(_Instagram["default"], null)), TYPES.WHATSAPP, /*#__PURE__*/_react["default"].createElement(_Whatsapp["default"], null)), TYPES.TELEGRAM, /*#__PURE__*/_react["default"].createElement(_Telegram["default"], null)), TYPES.TELEGRAM_WITHOUT_BG, /*#__PURE__*/_react["default"].createElement(_TelegramWithoutBg["default"], null)), TYPES.FACEBOOK_MESSENGER, /*#__PURE__*/_react["default"].createElement(_FacebookMessenger["default"], null)), TYPES.FACEBOOK, /*#__PURE__*/_react["default"].createElement(_Facebook["default"], null)), TYPES.VIBER, /*#__PURE__*/_react["default"].createElement(_Viber["default"], null)), TYPES.MAIL, /*#__PURE__*/_react["default"].createElement(_Mail["default"], null)), TYPES.VK, /*#__PURE__*/_react["default"].createElement(_Vk["default"], null));
var Messenger = exports.Messenger = function Messenger(props) {
  var type = props.type,
    className = props.className;
  return /*#__PURE__*/_react["default"].createElement(StyledMessenger, {
    title: type,
    className: className
  }, ICONS[type] || /*#__PURE__*/_react["default"].createElement(_Default["default"], null));
};
var StyledMessenger = _styledComponents["default"].div.withConfig({
  displayName: "Messenger__StyledMessenger",
  componentId: "sc-189iwbs-0"
})(["width:100%;overflow:hidden;min-width:16px;height:auto;max-width:30px;> svg{height:100%;width:100%;}"]);